import React from "react";
import Layout from "../Component/Layout";
import { useNavigate } from "react-router-dom";
import { FaSitemap } from "react-icons/fa";

const LocationHome = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/cable/location/location-master");
  };

  return (
    <Layout>
      <div
        style={{
          padding: "30px 40px",
          backgroundColor: "#f8fafc",
          minHeight: "calc(100vh - 60px)",
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: "35px" }}>
          <h2
            style={{
              margin: "0 0 8px 0",
              color: "#0f172a",
              fontWeight: "700",
              fontSize: "28px",
            }}
          >
            Location
          </h2>

          <p
            style={{
              color: "#64748b",
              margin: 0,
              fontSize: "15px",
            }}
          >
            Manage location configuration.
          </p>
        </div>

        {/* Tile */}
        <div
          onClick={handleNavigate}
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)",
            padding: "24px",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            height: "160px",
            width: "260px",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-6px)";
            e.currentTarget.style.boxShadow =
              "0 20px 25px -5px rgba(0,0,0,0.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 4px 6px -1px rgba(0,0,0,0.05)";
          }}
        >
          {/* Icon */}
          <div
            style={{
              background: "linear-gradient(135deg, #eff6ff, #dbeafe)",
              color: "#3b82f6",
              padding: "14px",
              borderRadius: "12px",
              width: "fit-content",
            }}
          >
            <FaSitemap size={26} />
          </div>

          {/* Tile Name */}
          <div style={{ marginTop: "auto" }}>
            <h5
              style={{
                fontSize: "16px",
                fontWeight: "600",
                margin: "0 0 6px 0",
              }}
            >
              Location Master
            </h5>

            <p
              style={{
                fontSize: "13px",
                color: "#64748b",
                margin: 0,
              }}
            >
              Manage locations
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LocationHome;